import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { RouteService } from 'src/app/core/services';
import { PromiseHelper } from 'src/app/helpers';
import { RecaptchaComponent } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  user = {
    email: '',
    password: '',
    captcha: '',
  }

  submitting = false;
  submitted  = false;

  @ViewChild(RecaptchaComponent, { static: false })
  recaptcha?: RecaptchaComponent;
  recaptchaEnabled = environment.recaptcha.enabled;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private flashMessage: FlashMessagesService,
    private routeService: RouteService,
  ) { }

  ngOnInit(): void {
    this.initRedirect();
  }

  private initRedirect() {
    const url = this.route.snapshot.queryParamMap.get('redirect') || '';

    if (url) this.routeService.rememberRedirectAfterLogin(url);
  }

  resolvedCaptcha(response: string) {
    this.user.captcha = response;
  }

  // Submit login form
  onSubmit(form: FormGroup) {
    this.submitted = true;

    if (this.submitting) {
      return;
    }

    if (form.invalid) {
      return;
    }

    this.submitting = true;

    PromiseHelper.setTimeout(() => this.doLogin(), 10000).finally(() => {
      this.submitting = false;
    });
  }

  private async doLogin() {
    const captcha = this.user.captcha;

    if (this.recaptchaEnabled && !captcha) {
      return;
    }

    const creds = {
      email:    this.user.email,
      password: this.user.password,
    };

    try {
      // Authenticate user and get token
      const data: any = await this.auth.authenticateUser(creds, captcha).toPromise();

      // Check if creds changed during submission or operation timed out
      if (creds.email !== this.user.email) {
        this.recaptcha?.reset();
        return;
      }

      // User authenticated, store token
      if (data.success) {
        this.auth.storeUserData(data.token, data.user);
        this.auth.storeAdminStatus(false);

        // Redirect to home page
        this.routeService.redirectAfterLogin();

        // Display log in to user
        this.flashMessage.show("You have been logged in.", {
          cssClass: 'alert-success',
          timeout: 3000
        });
      }
      else {
        this.user.captcha = '';
        this.recaptcha?.reset();
        this.submitted = false;
      }
    }
    catch (err) {
      this.user.captcha = '';
      this.recaptcha?.reset();
      this.submitted = false;
      throw err;
    }
  }
}
